import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import './style.css';

// import closeIcon from '../../close.svg';
import infoIcon from '../../Icons/AnimatedIcons/info.json';
import warningIcon from '../../Icons/AnimatedIcons/warning.json';
import successIcon from '../../Icons/AnimatedIcons/success.json';
import errorIcon from '../../Icons/AnimatedIcons/error.json';

function PopModal({ isOpen, type, showCancelButton, confirmButtonText, cancelButtonText, onConfirm = null, onCancel = null, children }) {

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (onConfirm) onConfirm();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onConfirm]);


    if (!isOpen) return null;

    // Icon handling based on the icon type passed
    const getIcon = (iconType) => {
        switch (iconType) {
            case 'success':
                return successIcon;
            case 'error':
                return errorIcon;
            case 'info':
                return infoIcon;
            case 'warning':
                return warningIcon;
            default:
                return null;
        }
    };



    return (
        <div className="pop-up-modal-overlay" >
            <div className="pop-up-modal-content" onClick={(e) => e.stopPropagation()}>
                {/* <img src={closeIcon} alt='close' width={25} height={25} className="pop-up-close-button" onClick={onClose} /> */}
                {type.icon &&
                    <div className='modalIconContainer'>
                        <Lottie
                            animationData={getIcon(type.icon)}
                            loop={false}
                            autoplay
                            style={{ width: 175, height: 175 }}  // Customize size
                        />
                    </div>
                }
                <div className='modalContentContainer'>
                    <h2>{type.title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: type.text }}/>
                </div>
                <div className='modalButtonContainer'>
                    {showCancelButton &&
                        <div>
                            <button className='cancel' onClick={onCancel}>{cancelButtonText}</button>
                        </div>
                    }
                    <div>
                        <button className='success' onClick={onConfirm}>{confirmButtonText ? confirmButtonText : 'OK'}</button>
                    </div>
                </div>
                {children}
            </div>
        </div>
    )
}

export default PopModal;